import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

// services/navigation-state.service.ts
@Injectable({ providedIn: 'root' })
export class NavigationStateService {
  private currentPersonSubject = new BehaviorSubject<'recipient' | 'applicant'>('recipient');
  public currentPerson$ = this.currentPersonSubject.asObservable();
  
  setCurrentPerson(person: 'recipient' | 'applicant') {
    this.currentPersonSubject.next(person);
  }
  
  getCurrentPerson(): 'recipient' | 'applicant' {
    return this.currentPersonSubject.value;
  }
}